export const rpc = async ({method, params, setErrorMessage, setOpenErrorDialog, onSuccess}) => {
  const rpcParams = new URLSearchParams();
  const rpc = {jsonrpc: "2.0", method, id: method, params};
  rpcParams.append("request", JSON.stringify(rpc));
  try {
    const response = await fetch('/itvs-site/jsonrpc', {
      method: "post",
      headers : {
        'Accept': 'application/json',
      },
      body: rpcParams,
    });
    const json = await response.json();
    if (json.error) {
      setErrorMessage(json.error.message);
      setOpenErrorDialog(true); 
    } else if (onSuccess) {
      onSuccess(json.result);
    }
  } catch (err) {
    console.error(err);
    setErrorMessage(`${method} failed: ${err}`);
    setOpenErrorDialog(true);
  }
};